$('.btn-export').on('click', function () {
    showExportModal().then();
});

async function showExportModal() {
    const plantId = $("#plant-id").val();
    const orderId = $("#order_id").val();
    const selectedDocumentIds = getSelectedDocumentIds();

    const dataString = JSON.stringify({
        'orderId': orderId,
        'selectedSearchId': getSelectedSearchId(),
        'selectedDocumentIds': selectedDocumentIds
    });

    const data = await $.get(`/plants/${plantId}/exports?orderId=${orderId}`);
    $("#export-modal-content").html(data);
    $('.export-modal-metadata').val(dataString);
    mapExportEvents();
    fillDefaultMargins();
    $('#export-modal').modal('show');
}

function fillDefaultMargins() {
    const plantId = $("#plant-id").val();
    $.get(`/plants/${plantId}/exports/margins`, function (data) {
        JSON.stringify(data);
        if (data['margins']) {
            $('#exportType_marginTop').val(data['margins'].top);
            $('#exportType_marginBottom').val(data['margins'].bottom);
            $('#exportType_marginRight').val(data['margins'].right);
            $('#exportType_marginLeft').val(data['margins'].left);
        }
    });
}

function mapExportEvents(keepRenderedValues) {
    const exportFormatGroup = $("input:radio[name='exportType[exportFormat]']");
    const chainSheetOptionsSection = $('.chain-sheet-options-section');
    const customMarginsCheckbox = $('#exportType_setMargins');
    const customMarginsSection = $('.custom-margin-section');
/* //kept in case a ui is desired for background shading
    if(document.getElementById("checkbox-related").checked) {
        document.getElementById("exportType_chainSheetOptions_docRelatedColor").checked = true;
    }
    if(document.getElementById("checkbox-primary").checked) {
        document.getElementById("exportType_chainSheetOptions_docPrimaryColor").checked = true;
    }*/

    exportFormatGroup.on('change', function () {
        const selectedOption = getSelectedExportFormat();

        if (selectedOption === 'email') {
            $('.email-form-section').removeClass('collapse');
        } else {
            $('.email-form-section').addClass('collapse');
        }

        const sectionsDiv = $('.sections-to-include-section');
        const sectionCheckboxes = sectionsDiv.find('input');
        const sectionLabels = sectionsDiv.find('label');
        const customMarginsCheckboxSection = $('.custom-margins-checkbox-section');
        const otherFormatSection = $('.other-format-section');

        if (selectedOption === 'links' || selectedOption === 'zip' || selectedOption === 'other') {
            sectionCheckboxes.prop('disabled', true);
            sectionCheckboxes.prop('checked', false);
            sectionLabels.addClass('text-muted');
            sectionLabels.parent().addClass('text-muted');
            addRemoveNotes($('#exportType_includeChainSheet').is(":checked"));
            chainSheetOptionsSection.addClass('collapse');
        } else {
            sectionCheckboxes.prop('disabled', false);
            sectionLabels.removeClass('text-muted');
            sectionLabels.parent().removeClass('text-muted');
            addRemoveNotes($('#exportType_includeChainSheet').is(":checked"));
        }

        if (selectedOption === 'other') {
            otherFormatSection.removeClass('collapse');
            customMarginsCheckboxSection.addClass('collapse');
            customMarginsCheckboxSection.addClass('collapse');
            customMarginsSection.addClass('collapse');
            customMarginsCheckbox.prop('checked', false);
        } else {
            otherFormatSection.addClass('collapse');
            customMarginsCheckboxSection.removeClass('collapse');
            customMarginsCheckboxSection.removeClass('collapse');
        }
    });

    $('#exportType_includeChainSheet').on('change', function () {
        if (this.checked) {
            chainSheetOptionsSection.removeClass('collapse');
        } else {
            chainSheetOptionsSection.addClass('collapse');
        }
    });

    customMarginsCheckbox.on('click', function () {
        if (this.checked) {
            customMarginsSection.removeClass('collapse');
        } else {
            customMarginsSection.addClass('collapse');
        }
    });

    $(".margins").blur(function () {
        if ($(this).val().includes('/')) {
            const number = parseInt($(this).val().split('/')[0]) / parseInt($(this).val().split('/')[1]);
            $(this).val(number);
        }
    });

    $(".margins").on('keyup', function () {
        if ($(this).val().charAt(0) === '.') {
            $(this).val('0' + $(this).val());
        }
    });

    // A new modal starts with fallout off. A validation error redraws the
    // submitted form, and this reset would clear Exclude Fallout.
    if (!keepRenderedValues) {
        addRemoveFallout(false);
    }
    var DocsToExport = $("input:radio[name='exportType[documentSelection]']");
    DocsToExport.on('change', function () {
        var selected = getSelectedDocumentsToExport();

        if (selected === 'allTabs') {
            addRemoveFallout(true);
            addIncludeAdditionalInfo(true);
        } else {
            addRemoveFallout(false);
            addIncludeAdditionalInfo(false);
        }
    });

    $('#exportType_includeChainSheet').click(function () {
        addRemoveNotes(this.checked);
        if (getSelectedDocumentsToExport() === 'allTabs') {
            addRemoveFallout(this.checked);
            addIncludeAdditionalInfo(this.checked);
        }
    });

    exportFormatGroup.trigger('change');

    if (keepRenderedValues) {
        restoreRenderedExportControls();
    }

    $('.export-submit-btn').on('click', submitExport);

    // Enter inside a text field can submit the form without going through the button.
    $('#export-modal').find('form').on('submit', submitExport);
}

function submitExport(e) {
    e.preventDefault();
    var selectedOption = getSelectedExportFormat();
    var exportModal = $('#export-modal');
    var exportForm = exportModal.find('form');
    var failureMessage = '<div class="text-center">The export could not be started. Please try again.</div>';

    if (selectedOption === 'email' && !exportRecipientEmailIsValid(exportForm)) {
        return;
    }

    if (selectedOption === 'email' || selectedOption === 'links') {
        exportForm.attr('target', '');
        $("#export-modal-content").html(selectedOption === 'email'
            ? '<div class="text-center">Sending Email</div>'
            : '<div class="text-center">Compiling links</div>');

        $.post(exportForm.attr('action'), exportForm.serialize())
            .done(function (data) {
                $("#export-modal-content").html(data);
            })
            .fail(function (xhr) {
                var html = xhr && xhr.responseText ? xhr.responseText : '';

                if (html.indexOf('export-submit-btn') !== -1) {
                    $("#export-modal-content").html(html);
                    mapExportEvents(true);
                    return;
                }

                $("#export-modal-content").html(failureMessage);
            });

        return;
    }

    if (selectedOption === 'other') {
        // A custom format answers with the file itself, so the response has to reach the
        // browser directly. target is set here because the email/links branch clears it,
        // and the native submit avoids re-entering this handler.
        exportForm.attr('target', '_blank');
        exportForm.get(0).submit();
        exportModal.modal('hide');

        return;
    }

    // The tab is opened during the click so the browser does not treat it as a
    // popup; its location is set once the server is holding the options.
    var exportTab = window.open('', '_blank');

    if (!exportTab) {
        $("#export-modal-content").html('<div class="text-center">Your browser blocked the export tab. Allow pop-ups for this site and try again.</div>');

        return;
    }

    $.post(exportForm.attr('action'), exportForm.serialize())
        .done(function (data) {
            // Anything but our JSON means the export never started: a session that
            // expired mid-request answers 200 with the login page.
            if (!data || !data.url) {
                exportTab.close();
                $("#export-modal-content").html(failureMessage);

                return;
            }

            exportTab.location = data.url;
            exportModal.modal('hide');
        })
        .fail(function () {
            exportTab.close();
            $("#export-modal-content").html(failureMessage);
        });
}

function addRemoveFallout(checked) {
    var falloutCheckbox = $('#exportType_excludeFalloutTab');
    if (checked) {
        falloutCheckbox.prop('disabled', false);
        falloutCheckbox.removeClass('text-muted');
        falloutCheckbox.parent().removeClass('text-muted');
    } else {
        falloutCheckbox.prop('checked', false);
        falloutCheckbox.prop('disabled', true);
        falloutCheckbox.addClass('text-muted');
        falloutCheckbox.parent().addClass('text-muted');
    }
}

function addRemoveNotes(checked) {
    var notesDiv = $('.notes-section');
    var notesCheckboxes = notesDiv.find('input');
    if (checked) {
        notesCheckboxes.prop('disabled', false);
        notesCheckboxes.removeClass('text-muted');
        notesCheckboxes.parent().removeClass('text-muted');
    } else {
        notesCheckboxes.prop('checked', false);
        notesCheckboxes.prop('disabled', true);
        notesCheckboxes.addClass('text-muted');
        notesCheckboxes.parent().addClass('text-muted');
    }
}

function addIncludeAdditionalInfo(checked) {
    var additionalInfoCheckbox = $('#exportType_includeAdditionalInfoTab');

    additionalInfoCheckbox.prop('checked', checked);
}

// Open or grey out each section to match the boxes in the redrawn form.
function restoreRenderedExportControls() {
    var chainChecked = $('#exportType_includeChainSheet').is(':checked');
    var chainSection = $('.chain-sheet-options-section');

    if (chainChecked) {
        chainSection.removeClass('collapse');
    } else {
        chainSection.addClass('collapse');
    }

    addRemoveNotes(chainChecked);

    if (getSelectedDocumentsToExport() === 'allTabs') {
        addRemoveFallout(true);
    } else {
        addRemoveFallout(false);
    }

    var marginsSection = $('.custom-margin-section');
    if ($('#exportType_setMargins').is(':checked')) {
        marginsSection.removeClass('collapse');
    } else {
        marginsSection.addClass('collapse');
    }
}

function exportRecipientEmailIsValid(exportForm) {
    var input = exportForm.find('[name="exportType[emailOptions][recipientEmail]"]');
    input.parent().find('.text-danger').remove();

    // Dot-atom with a dotted domain, so a leading or doubled dot fails here.
    var email = $.trim(input.val() || '');
    var exportEmailPattern = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)+$/;
    if (exportEmailPattern.test(email)) {
        return true;
    }

    $('.email-form-section').removeClass('collapse');
    input.after('<div class="text-danger export-email-error">Enter a valid email address.</div>');
    input.trigger('focus');

    return false;
}

function getSelectedExportFormat() {
    return $("input:radio[name='exportType[exportFormat]']:checked").val();
}

function getSelectedDocumentsToExport() {
    return $("input:radio[name='exportType[documentSelection]']:checked").val();
}
